import { render, staticRenderFns } from "./TableCellLink.vue?vue&type=template&id=65828609&scoped=true&"
import script from "./TableCellLink.vue?vue&type=script&lang=js&"
export * from "./TableCellLink.vue?vue&type=script&lang=js&"
import style0 from "./TableCellLink.vue?vue&type=style&index=0&id=65828609&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65828609",
  null
  
)

export default component.exports